/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentBracketTypeOption
 */
export interface TournamentBracketTypeOption {
    /**
     * Internal key (e.g., SINGLE_ELIMINATION)
     * @type {string}
     * @memberof TournamentBracketTypeOption
     */
    key: string;
    /**
     * Display label (e.g., "Single Elimination")
     * @type {string}
     * @memberof TournamentBracketTypeOption
     */
    label: string;
    /**
     * Explanation of format
     * @type {string}
     * @memberof TournamentBracketTypeOption
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentBracketTypeOption
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof TournamentBracketTypeOption
     */
    sortOrder: number;
}

/**
 * Check if a given object implements the TournamentBracketTypeOption interface.
 */
export function instanceOfTournamentBracketTypeOption(value: object): value is TournamentBracketTypeOption {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function TournamentBracketTypeOptionFromJSON(json: any): TournamentBracketTypeOption {
    return TournamentBracketTypeOptionFromJSONTyped(json, false);
}

export function TournamentBracketTypeOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentBracketTypeOption {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'description': json['description'] == null ? undefined : json['description'],
        'enabled': json['enabled'],
        'sortOrder': json['sortOrder'],
    };
}

export function TournamentBracketTypeOptionToJSON(json: any): TournamentBracketTypeOption {
    return TournamentBracketTypeOptionToJSONTyped(json, false);
}

export function TournamentBracketTypeOptionToJSONTyped(value?: TournamentBracketTypeOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'label': value['label'],
        'description': value['description'],
        'enabled': value['enabled'],
        'sortOrder': value['sortOrder'],
    };
}

